'use client'
import { Box, Flex, Loader, Text } from '@mantine/core'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { ReactNode, useState } from 'react'

import { BASE_PATH } from '@/configs/const'
import { I18nLink } from '@/i18n/navigation'
import { setSelectedCurrency } from '@/server/actions'

import styles from './index.module.css'

interface ConversionCardProps {
  icon: ReactNode
  text: string
  href: string
  currencyCode: string
}

export default function ConversionCard({ icon, text, href, currencyCode }: ConversionCardProps) {
  const params = useParams<{ locale: string }>()
  const [isLoading, setIsLoading] = useState(false)
  const t = useTranslations('common')

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    if (isLoading) return

    setIsLoading(true)

    try {
      await setSelectedCurrency(currencyCode)
      window.location.href = `/${params.locale}${BASE_PATH}${href}`
    } catch (error) {
      setIsLoading(false)
    }
  }

  return (
    <I18nLink
      href={href}
      className={styles.card}
      onClick={handleClick}
      aria-disabled={isLoading}
      style={{
        pointerEvents: isLoading ? 'none' : 'auto',
        opacity: isLoading ? 0.7 : 1,
      }}
    >
      <Flex align="center" gap={12}>
        <Box
          w={24}
          h={24}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {isLoading ? <Loader size="xs" color="var(--content-secondary)" /> : icon}
        </Box>
        <Text c="var(--content-primary)" lineClamp={1} fz={14} fw={500} lh="20px">
          {isLoading ? t('loading') : text}
        </Text>
      </Flex>
    </I18nLink>
  )
}
